import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=b81ae0de&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=b81ae0de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b81ae0de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b81ae0de')) {
      api.createRecord('b81ae0de', component.options)
    } else {
      api.reload('b81ae0de', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=b81ae0de&scoped=true&", function () {
      api.rerender('b81ae0de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2QDeX9E4o6ykp/JS/comp/GuestBox.vue"
export default component.exports